<script lang="ts">
  export let width = "100%";
  export let height = 16;
  export let light = false;
</script>

<span
  class="inline-block rounded-md animate-pulse"
  class:light
  style:width
  style:height="{height}px"
></span>

<style lang="postcss">
  span {
    @apply bg-white/10;
  }

  span.light {
    @apply bg-white/5;
  }
</style>
